export var ECaptchaStage = /*#__PURE__*/function (ECaptchaStage) {
  ECaptchaStage["init"] = "init";
  ECaptchaStage["start"] = "start";
  ECaptchaStage["retry"] = "retry";
  ECaptchaStage["end"] = "end";
  ECaptchaStage["error"] = "error";
  ECaptchaStage["blocked"] = "blocked";
  ECaptchaStage["captcha"] = "captcha";
  ECaptchaStage["recaptcha"] = "recaptcha";
  return ECaptchaStage;
}({});